export default __webpack_public_path__ + "static/media/thermon.525199e3.png";